import axios from "axios"
import { env } from '../constants'

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })

/* Templates */
export const templates = () => axios.get(`${env.startpoint}/admin/notification/templates`, auth()).then(r => r).catch(e => e.response)
export const createTemplate = data => axios.post(`${env.startpoint}/admin/notification/templates/create`, data, auth()).then(r => r).catch(e => e.response)
export const deleteTemplate = id => axios.delete(`${env.startpoint}/admin/notification/templates/${id}`, auth()).then(r => r).catch(e => e.response)

/* Users list */
export const users = data => axios.post(`${env.startpoint}/admin/notification/users`, data, auth()).then(r => r).catch(e => e.response)

/* Send notification */
export const send = data => axios.post(`${env.startpoint}/admin/notification/send`, data, auth()).then(r => r).catch(e => e.response)

/* Image of the notification */
export const uploadImage = data => {
    const headers = { headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "multipart/form-data" } }
    return axios.post(`${env.startpoint}/admin/notification/upload-image`, data, headers).then(r => r).catch(e => e.response)
}
export const removeImage = image => axios.post(`${env.startpoint}/admin/notification/remove-image`, { image }, auth()).then(r => r).catch(e => e.response)
